import { Injectable } from '@angular/core';
// @ts-ignore
import { UserManager, User, WebStorageStateStore, Log, UserManagerSettings } from 'oidc-client';
import {environment} from '../../../environments/environment';

@Injectable()
export class AuthService {
  private userManager: UserManager;
  user: User;
  isUsingVnConnect: boolean;
  constructor() {
  }
  login(): Promise<any> {
    return this.userManager.signinRedirect({ state: window.location.href });
  }
  register() {
    location.href = `${this.userManager.settings.authority}account/register?returnUrl=${location.href}`;
  }
  profile() {
    // location.href = `${this.userManager.settings.authority}manage/index`;
    window.open(`${this.userManager.settings.authority}manage/index`, '_blank');
  }
  logout(): any {
    return this.userManager.signoutRedirect();
  }
  isLoggedIn(): boolean {
    return this.user && this.user.access_token && !this.user.expired;
  }
  getAccessToken(): string {
    return this.user ? this.user.access_token : '';
  }
  signoutRedirectCallback(): Promise<any> {
    return this.userManager.signoutRedirectCallback();
  }

  completeAuthentication(): Promise<void> {
    return this.userManager.signinRedirectCallback().then(user => {
            // console.log(user);
            this.replaceAndNavigate(user);
        })
        .catch(error => {
            // console.error(error);
        });
}

replaceAndNavigate(user) {
    window.history.replaceState({},
        window.document.title,
        window.location.origin);
    window.location = user.state || "/";
}

  setupUserManager() {
      var config: UserManagerSettings;
      if (environment.isUsingVnConnect) {
        config = {
            authority: environment.apiGatewayUrl,
            client_id: 'SOZpkVS7mDActaD2VC9geFA3R0oa',
            client_secret: 'n8Two4YlGPf5lt_iCzTwbuiPScka',
            redirect_uri: `${location.origin}/login-redirect.html`,
            post_logout_redirect_uri: `${location.origin}/?postLogout=true`,
            response_type: "code",
            scope: "openid profile email",
            filterProtocolClaims: true,
            loadUserInfo: true,
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            metadata: {
                issuer: environment.authenApiUrl + `oauth2/token`,
                authorization_endpoint: environment.authenApiUrl + `oauth2/authorize`,
                token_endpoint: environment.apiGatewayUrl + `oauth2/token`,
                end_session_endpoint: environment.authenApiUrl + `oidc/logout`,
                revocation_endpoint: environment.apiGatewayUrl + `oauth2/revoke`,
                check_session_iframe: environment.authenApiUrl + `oidc/checksession?client_id=SOZpkVS7mDActaD2VC9geFA3R0oa&redirect_uri=` + `${location.origin}/login-redirect.html`,
                jwks_uri: environment.authenApiUrl + `oauth2/jwks`,
                userinfo_endpoint: environment.apiGatewayUrl + `oauth2/userinfo`,
                introspection_endpoint: environment.authenApiUrl + `oauth2/introspect`
            }
        };
    } else {
        config = {
            authority: environment.authenApiUrl, // URL Authorization Service
            client_id: 'vilis-client',
            redirect_uri: `${location.origin}/login-redirect.html`,
            scope: 'openid authorize-vilis-api profile offline_access',
            response_type: 'id_token token',
            client_secret: 'y47XC$2Xz3h^7R',
            post_logout_redirect_uri: `${location.origin}?postLogout=true`,
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            //automaticSilentRenew: true,
            //silent_redirect_uri: `${location.origin}/silent-renew.html`
        };
    }
    this.userManager = new UserManager(config);
    this.userManager.getUser().then(user => {
      if (user && !user.expired) {
        this.user = user;
        // this.loadSecurityContext();
      }
    });
    this.userManager.events.addUserLoaded(args => {
      this.userManager.getUser().then(user => {
        this.user = user;
      });
    });
  }
}
